// =========================
// USER CARD COMPONENT
// =========================

// External Libraries
import { LitElement, html, css } from 'lit';

// App Modules
import Utils from '../Utils';
import { gotoRoute } from '../Router';

// This component is used to display a user card in the popin
class PopinUserCard extends LitElement {
  static properties = {
    user: { type: Object },
  };

  // This function handles the click event on the card
  handleCardClick() {
    gotoRoute(`/profile?user=${this.user._id}`);
  }

  render() {
    if (!this.user) return;

    const name = `${this.user.firstName} ${this.user.lastName}`;
    const profileImage = Utils.getProfileImage(this.user);

    return html`
      <div class="card" @click=${this.handleCardClick}>
        <img class="profile-image" src="${profileImage}" alt="${name}" />
        <div class="name">${name}</div>
      </div>
    `;
  }

  static styles = css`
    .card {
      cursor: pointer;
      background: white;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      padding: 1rem;
      transition: transform 0.2s;
    }

    .card:hover {
      transform: translateY(-4px);
    }

    .profile-image {
      width: 100%;
      aspect-ratio: 1;
      object-fit: cover;
      border-radius: 8px;
    }

    .name {
      font-size: 1.2rem;
      font-weight: bold;
      margin-top: 0.75rem;
    }
  `;
}

customElements.define('popin-user-card', PopinUserCard);
